/* External */
import { all } from "redux-saga/effects";

/* Services */
import { backendService } from "../../../services";

/* Others */
import { ACTION_TYPES_BASE_NAME } from "./actions";
import { PDP_ASSET_TYPES, makeFetchSaga } from "../../../utils";

const fetchPdpContinueWatchingSaga = makeFetchSaga(
  ACTION_TYPES_BASE_NAME,
  {
    getFunc: ({ assetType }) => {
      if (assetType === PDP_ASSET_TYPES.series) return backendService.experience.getContinueWatchingShowPdp;

      return backendService.experience.getContinueWatchingMovie;
    },
    getParams: ({ assetId }) => [assetId]
  },
  (data) => data?.section?.items?.[0]
);

export default function* () {
  yield all([fetchPdpContinueWatchingSaga]);
}
